import React from 'react';
import { motion } from 'framer-motion';
import { X, Check } from 'lucide-react';
export function WhyItFailedSection() {
  const comparisons = [{
    bad: 'Contacto cero desde la fuerza de voluntad (aguantar las ganas).',
    good: 'Contacto cero desde la comprensión emocional (soltar la necesidad).'
  }, {
    bad: 'Hablarlo una y otra vez con amigas esperando sentirte mejor.',
    good: 'Procesar el dolor internamente a través de actos simbólicos.'
  }, {
    bad: 'Distraerte trabajando o saliendo para "no pensar".',
    good: 'Atravesar la incomodidad de forma guiada para sanarla de raíz.'
  }, {
    bad: 'Esperar que él te dé una explicación o una disculpa.',
    good: 'Darte tú misma el cierre que necesitas para avanzar.'
  }];
  return <section className="py-20 md:py-24 px-4 bg-blush relative" data-id="element-387">
      <div className="absolute top-0 left-0 w-full overflow-hidden leading-none rotate-180" data-id="element-388">
        <svg className="relative block w-full h-[40px]" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none" data-id="element-389">
          <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" fill="#F8F3EE" data-id="element-390"></path>
        </svg>
      </div>

      <div className="max-w-4xl mx-auto pt-10" data-id="element-391">
        <div className="text-center mb-14" data-id="element-392">
          <h2 className="font-serif font-bold text-3xl md:text-5xl text-primary mb-4" data-id="element-393">
            No fallaste tú.{' '}
            <span className="italic text-accent" data-id="element-394">Falló el enfoque.</span>
          </h2>
          <p className="font-sans text-ink/70 text-lg max-w-2xl mx-auto" data-id="element-395">
            Lo que has intentado hasta ahora probablemente solo ha puesto una
            curita sobre una herida profunda.
          </p>
        </div>

        <div className="bg-white rounded-3xl shadow-xl border border-soft/40 overflow-hidden" data-id="element-396">
          <div className="grid grid-cols-2" data-id="element-397">
            <div className="p-4 md:p-6 text-center font-sans font-bold text-urgency text-sm md:text-base bg-urgency/5 border-b-2 border-urgency/20" data-id="element-398">
              ❌ Lo tradicional
            </div>
            <div className="p-4 md:p-6 text-center font-sans font-bold text-relief text-sm md:text-base bg-relief/5 border-b-2 border-relief/20" data-id="element-399">
              ✅ El Código del Cierre™
            </div>
          </div>

          <div className="divide-y divide-soft/30" data-id="element-400">
            {comparisons.map((row, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="grid grid-cols-2" data-id="element-401">
                <div className="p-4 md:p-6 flex items-start gap-2 text-ink/70 text-xs sm:text-sm md:text-base font-sans" data-id="element-402">
                  <X className="text-urgency shrink-0 mt-0.5" size={18} data-id="element-403" />
                  <span data-id="element-404">{row.bad}</span>
                </div>
                <div className="p-4 md:p-6 flex items-start gap-2 text-primary font-medium bg-relief/5 text-xs sm:text-sm md:text-base font-sans" data-id="element-405">
                  <Check className="text-relief shrink-0 mt-0.5" size={18} data-id="element-406" />
                  <span data-id="element-407">{row.good}</span>
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}